export { FolderAlt as default } from './FolderAlt';
